import { ISanityItemOptionModifier } from '@rbi-ctg/menu';

import { and, every, maxLengthWithDefaultValue } from '..';

export const onlyDefaultModifierIsAvailable = and(
  maxLengthWithDefaultValue<ISanityItemOptionModifier[]>(1, []),
  every(modifier => modifier.default)
);
